import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import "aos/dist/aos.css";
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/tailwind.css";
import "./styles/index.css";
import "./styles/font.css";

function deferCSS(href) {
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.media = "print";
  link.onload = () => {
    link.media = "all";
  };
  document.head.appendChild(link);
}

const criticalFonts = `
  @font-face {
    font-family: 'Playfair Display';
    font-style: normal;
    font-weight: 400;
    src: url('https://fonts.gstatic.com/s/playfairdisplay/v30/nuFiD-vYSZviVYUb_rj3ij__anPXDTzYh2I.woff2') format('woff2');
    font-display: swap;
  }
  @font-face {
    font-family: 'Quicksand';
    font-style: normal;
    font-weight: 400;
    src: url('https://fonts.gstatic.com/s/quicksand/v30/6xKtdSZaM9iE8KbpRA_pgH8.woff2') format('woff2');
    font-display: swap;
  }
  body, html {
    font-family: 'Quicksand', 'Playfair Display', Arial, sans-serif;
  }
`;
const styleTag = document.createElement("style");
styleTag.textContent = criticalFonts;
document.head.appendChild(styleTag);

// Utility to load external scripts on demand
export function loadScript(src, globalFlag, callback) {
  if (window[globalFlag]) {
    callback && callback();
    return;
  }
  const script = document.createElement("script");
  script.src = src;
  script.async = true;
  script.onload = () => {
    window[globalFlag] = true;
    callback && callback();
  };
  document.head.appendChild(script);
}

window.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    // Defer chat widget loading
    if (!window.chatWidgetLoaded) {
      const chatScript = document.createElement("script");
      chatScript.src =
        process.env.REACT_APP_CHAT_WIDGET_URL ||
        "https://example.com/chat-widget.js";
      chatScript.async = true;
      chatScript.onload = () => {
        window.chatWidgetLoaded = true;
      };
      document.head.appendChild(chatScript);
    }
  }, 6000);

  // Defer favicon injection (non-blocking)
  setTimeout(() => {
    const favicon180Url = process.env.REACT_APP_FAVICON_180_URL;
    const favicon32Url = process.env.REACT_APP_FAVICON_32_URL;
    const favicon16Url = process.env.REACT_APP_FAVICON_16_URL;

    const createFaviconLink = (rel, sizes, href, type = "image/png") => {
      const link = document.createElement("link");
      link.rel = rel;
      link.sizes = sizes;
      link.href = href;
      if (type) link.type = type;
      document.head.appendChild(link);
    };
    if (favicon180Url)
      createFaviconLink("apple-touch-icon", "180x180", favicon180Url, null);
    if (favicon32Url) createFaviconLink("icon", "32x32", favicon32Url);
    if (favicon16Url) createFaviconLink("icon", "16x16", favicon16Url);
  }, 1000);

  deferCSS("/css/main.7ca95c27.css");
  deferCSS("/styles/tailwind.css");
  deferCSS("/styles/index.css");
  deferCSS("/styles/font.css");
});

// --- PERFORMANCE OPTIMIZATION END ---

const rootElement = document.getElementById("root");

const root = ReactDOM.createRoot(rootElement);

function hydrateApp() {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

// Use requestIdleCallback if available, otherwise fallback to setTimeout
if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrateApp, { timeout: 1000 });
} else if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(hydrateApp, 0);
  });
} else {
  setTimeout(hydrateApp, 0);
}
